import * as actions from './taskQueue.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { TaskQueueModel } from '@smarttask-common/src/lib/models/Record/Task/Queue/TaskQueueModel';

export const queueAdapter = createEntityAdapter<TaskQueueModel>({
    selectId: (x) => x.id,
});
export interface TaskQueueState extends EntityState<TaskQueueModel> {
    selected_id: string;
}

export const initialState: TaskQueueState = queueAdapter.getInitialState({
    selected_id: undefined,
});

export function TaskQueueReducers(state: TaskQueueState = initialState, action: actions.TaskQueueActions) {
    switch (action.type) {
        case actions.TaskQueueActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_id: action.selected_id };
            //console.log(state);
            return state;

        case actions.TaskQueueActionTypes.ADD_QUEUE:
            return queueAdapter.addOne(action.queue_item, state);

        case actions.TaskQueueActionTypes.ADD_QUEUES:
            return queueAdapter.addMany(action.queue, state);

        case actions.TaskQueueActionTypes.UPSERT_QUEUE:
            return queueAdapter.upsertOne(action.queue_item, state);

        case actions.TaskQueueActionTypes.UPSERT_QUEUES:
            return queueAdapter.upsertMany(action.queue, state);

        case actions.TaskQueueActionTypes.UPDATE_QUEUE:
            return queueAdapter.updateOne(action.queue_item, state);

        case actions.TaskQueueActionTypes.UPDATE_QUEUES:
            return queueAdapter.updateMany(action.queue, state);

        case actions.TaskQueueActionTypes.DELETE_QUEUE:
            // if(state.selectedTaskId == action.id){
            //   state.selectedTaskId = undefined;
            // }
            return queueAdapter.removeOne(action.id, state);

        case actions.TaskQueueActionTypes.DELETE_QUEUES:
            // if(action.ids.indexOf(state.selectedTaskId) > -1){
            //   state.selectedTaskId = undefined;
            // }
            return queueAdapter.removeMany(action.ids, state);

        case actions.TaskQueueActionTypes.DELETE_ALL_QUEUES:
            return queueAdapter.removeMany(action.ids, state);

        case actions.TaskQueueActionTypes.DELETE_ALL:
            return queueAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getTaskQueueState = createFeatureSelector<TaskQueueState>('taskQueue');

export const { selectIds, selectEntities, selectAll, selectTotal } = queueAdapter.getSelectors(getTaskQueueState);

const getSelectedTaskIdState = (state: TaskQueueState) => {
    return state.selected_id;
};
export const getSelectedTaskId = createSelector(getTaskQueueState, getSelectedTaskIdState);

export const getSelectedTask = createSelector(getTaskQueueState, (state: TaskQueueState) => {
    if (state.selected_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_id];
});
